<template>
  <v-container fluid grid-list-xl>
    <v-flex xs12>
      <h1>
        {{ $t('agreementManage') }}
      </h1>
    </v-flex>
    <v-layout row wrap class="mt-4" justify-space-around>
      <v-flex xs12 sm12 md4 lg3 v-for="item in items" :key="item.id" v-if="isProviderAllowed(item.code)">
        <v-card>
          <v-card-text class="text-xs-center">
            <img :src="getImgUrl(item.code)" width="150" height="100">

            <h2 class="text-xs-center" :style="`color: ${ textColor }`"> {{ item.name }} </h2>
            <v-btn color="" flat @click="createCarrier(item)" :loading="loading" :disabled="loading">
              {{ $t('createModel', { model: $tc('models.carrier', 1) }) }}
              <font-awesome-icon icon="plus" class="ml-1"></font-awesome-icon>
            </v-btn>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Setting from '@/client/setting'
import Provider from '@/client/provider'
import Carrier from '@/client/carrier'

export default {
  name: '',

  props: {},

  data () {
    return {
      items: [],
      textColor: process.env.VUE_APP_COLOR,
      carrier: {},
      agreementsCount: 0,
      notAllowedProviders: ['DhlPrepaidBot', 'DhlBot', 'GenericCarrier', 'Boxify', 'EnviaCom', 'Pakke', 'Teiker', 'Logispak', 'Onward']
    }
  },

  components: {
  },

  computed: {
  },

  methods: {
    async fetch () {
      this.loading = true
      await this.$auth.getCurrentUser()
      this.items = await Provider.all()
      this.agreementsCount = this.$auth.currentUser.own_agreements_count
      this.loading = false
    },

    getImgUrl(code){
      try{ 
        return require(`@/assets/providers/${code.toLowerCase().replaceAll(' ', '-')}.png`)
      }catch(_){
        return require(`@/assets/providers/sample-provider-logo.png`)
      }
    },

    async createCarrier(provider){
      this.carrier = new Carrier({
        name: this.carrierName(provider),
        provider_id: provider.id,
        own_agreements: true,
        user_id: this.$auth.currentUser.id,
        status: 'active'
      })

      var res = await this.carrier.save(true)

      this.$router.push({
        name: 'clientCarrierForm',
        params: { id: res.carrier.id }
      });
    },

    isProviderAllowed (code) {
      var index = this.notAllowedProviders.indexOf(code)
      return !(index >= 0)
    },

    carrierName (provider) {
      return `user-${this.$auth.currentUser.id}-${ provider.name.toLowerCase().replaceAll(' ', '-') }-${this.$auth.currentUser.id}${ (parseInt(this.agreementsCount) + 1) }`
    }
  },

  watch: {
  },

  async mounted () {
    var ownAgreements = await Setting.byKey('user_own_agreements') || {}
    if (ownAgreements && ownAgreements.value == '0') this.goTo('dashboard')

    this.fetch()
  }
}
</script>
